import React from 'react';
import { useSelector } from 'react-redux';

import Header from './header/Header';
import MessageCard from './message-card/MessageCard';
import EmptyGeneratedMessagesDisclaimer from './empty-generated-messages-disclaimer/EmptyGeneratedMessagesDisclaimer';
import CommonLoader from '../../../../components/common-loader/CommonLoader';

import scss from './AdjustedMessages.module.scss';

const MOCK_REDOING_MESSAGE_ID = '-1';

function AdjustedMessages() {
  const adjustedMessages = useSelector((state) => state.activ8Messages.adjustedMessages);
  const isAdjusting = useSelector((state) => state.activ8Messages.isAdjusting);

  return (
    <div className={scss.wrapper}>
      <Header />

      <div className={scss.messagesWrapper}>
        {adjustedMessages.length ? (
          adjustedMessages.map((message) => (
            <MessageCard key={message.id} message={message} isRedoing={message.id === MOCK_REDOING_MESSAGE_ID} />
          ))
        ) : !isAdjusting ? (
          <EmptyGeneratedMessagesDisclaimer />
        ) : null}

        <CommonLoader isLoading={isAdjusting} />
      </div>
    </div>
  );
}

export default AdjustedMessages;
